module.exports = "/_next/static/images/home-c2aafb35e697cc0681f43d501e4cd711.png";